import { Page } from '@/core/architecture'

import { MyRankingTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MyRanking Page
 * Implemented as a practical sample.
 */
export const MyRanking: Page = () => {
  const { state, actions } = useViewModel()

  return <MyRankingTemplate state={state} {...actions} />
}
